import { SET_GENERAL_REMARKS } from '../../actions/common';

export default function generalRemarks(state, action) {
  const initialState = {};
  const newState = Object.assign({}, state);

  switch (action.type) {
    case SET_GENERAL_REMARKS:
      newState[action.resultId] = {
        type: action.remarksType,
        content: action.remarks,
      };
      return newState;

    default:
      if (state === undefined) {
        return initialState;
      }
      return state;
  }
}
